import { render, staticRenderFns } from "./CashierView.vue?vue&type=template&id=428f5d46&scoped=true"
import script from "./CashierView.vue?vue&type=script&lang=js"
export * from "./CashierView.vue?vue&type=script&lang=js"
import style0 from "./CashierView.vue?vue&type=style&index=0&id=428f5d46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428f5d46",
  null
  
)

export default component.exports